import React from 'react';
import { OrderItemKind } from '../../utility/refund';
import { toFixedThree } from '../../utility/helper';

interface OrderItemUnitPriceProps {
    kind: OrderItemKind;
    unitBasePrice: number;
    unitModifierTotal: number;
    unitPrice: number;
}

const OrderItemUnitPrice: React.FC<OrderItemUnitPriceProps> = ({
    kind,
    unitBasePrice,
    unitModifierTotal,
    unitPrice,
}) => {
    if (kind === 'SIMPLE' || kind === 'BOX') {
        return (
            <>
                <div className="fw-bold">BHD {toFixedThree(unitPrice)}</div>
                <div className="small text-muted">{kind === 'BOX' ? 'Per box' : 'Per item'}</div>
            </>
        );
    }

    return (
        <div style={{ minWidth: '210px' }}>
            {kind === 'MODIFIER' && <div className="d-flex justify-content-between gap-3 small mb-1">
                <span>{kind === 'MODIFIER' && 'Base product'}</span>
                <span>BHD {toFixedThree(unitBasePrice)}</span>
            </div>}
            <div className="d-flex justify-content-between gap-3 small mb-2">
                <span>{kind === 'COMBO' ? 'Selected options' : 'add-ons'}</span>
                <span>BHD {toFixedThree(unitModifierTotal)}</span>
            </div>
            <div className="d-flex justify-content-between gap-3 border-top pt-2 fw-bold">
                <span>Per unit</span>
                <span>BHD {toFixedThree(unitPrice)}</span>
            </div>
        </div>
    );
};

export default OrderItemUnitPrice;
